import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';
import Constants from '../../common/constants';
import { getPagesByParams } from '../../actions/admin/pageAction';
import { IsEmpty } from '../../common/checks';
import OverLoading from '../global/OverLoading';

function PageList(props) {
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const pageOptions = [5, 10, 15, 20, 25];
  const [pageSize, setPageSize] = useState(pageOptions[0]);
  const [pageCount, setPageCount] = useState(0);
  const [pageName, setPageName] = useState('');
  const [id, setId] = useState(props.pageId);

  const fetchPages = async (params) => {
    const response = await getPagesByParams({ ...params, status: Constants.PageStatus.Live })();
    if (!IsEmpty(id)) {
      const index = response.rows.findIndex((el) => el.id === id);
      if (index !== -1) {
        response.rows[index].tableData = { checked: true };
      }
    }
    if (response) {
      setPages(response.rows);
      setPageCount(response.count);
      setLoading(false);
    }
  };

  const handleChangePage = async (e) => {
    setPageNo(e);
  };

  const handleChangeRowsPerPage = (e) => {
    setPageSize(e.target.value);
    setPageNo(0);
  };

  const handleSearch = (val) => {
    setPageNo(0);
    setPageName(val);
  };

  useEffect(() => {
    setLoading(true);
    fetchPages({ name: pageName, pageNo, pageSize });
  }, [pageSize, pageNo, pageName]);

  return (
    <>
      {loading && <OverLoading />}
      <MaterialTable
        columns={[
          { title: 'Page Id', field: 'id', width: '30px' },
          { title: 'Page Name', field: 'name', width: '30px' },
        ]}
        title="Pages"
        isloading={loading}
        data={pages}
        options={{
          actionsColumnIndex:    -1,
          search:                true,
          sorting:               true,
          paging:                true,
          emptyRowsWhenPaging:   false,
          selection:             true,
          pageSize:              pageOptions.slice(-1)[0],
          showSelectAllCheckbox: false,
          showTextRowsSelected:  false,
        }}
        onSearchChange={(val) => handleSearch(val)}
        onSelectionChange={(rows, selected) => {
          if (selected !== undefined) {
            rows.map((el) => {
              if (el.id !== selected.id) {
                el.tableData.checked = false;
              }
              return el;
            });
            if (selected.tableData.checked) {
              setId(selected.id);
              props.onChangedPageId(selected.id);
            } else {
              setId(null);
            }
          }
          return rows;
        }}
        components={{
          Pagination: (comProps) => (
            <TablePagination
              classes={comProps.classes}
              icon={comProps.icon}
              style={comProps.style}
              labelRowsPerPage={comProps.labelRowsPerPage}
              labelDisplayedRows={comProps.labelDisplayedRows}
              ActionsComponent={comProps.ActionsComponent}
              SelectProps={comProps.SelectProps}
              page={pageNo}
              onChangePage={(e, page) => {
                handleChangePage(page);
              }}
              onChangeRowsPerPage={(e) => {
                handleChangeRowsPerPage(e);
              }}
              rowsPerPageOptions={pageOptions}
              rowsPerPage={pageSize}
              count={pageCount}
            />
          ),
        }}
      />
      <div
        className="row"
        style={{
          justifyContent: 'space-between',
          marginTop:      30,
          marginLeft:     0,
          marginRight:    0,
        }}
      >
        <div>
          Page Selected ID:
          {' '}
          {id}
        </div>
        <Button
          disabled={!!(id === null || id === '')}
          onClick={() => { props.onActiveStepChanged(props.activeStep + 1); }}
          variant="contained"
          color="default"
        >
          Next
        </Button>
      </div>
    </>
  );
}

PageList.propTypes = {
  pageId:              PropTypes.number.isRequired,
  onActiveStepChanged: PropTypes.func.isRequired,
  activeStep:          PropTypes.number.isRequired,
  onChangedPageId:     PropTypes.func.isRequired,
};

export default connect(null, { getPagesByParams })(PageList);
